// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const brute_bonnet: PokeData = {
  "id": 986,
  "name": "brute-bonnet",
  "height": 12,
  "weight": 210,
  "base_experience": 285,
  "types": [
    PokeType.GRASS,
    PokeType.DARK
  ],
  "api_moves": [
    "thrash",
    "absorb",
    "mega-drain",
    "growth",
    "solar-beam",
    "stun-spore",
    "spore",
    "giga-drain",
    "synthesis",
    "ingrain",
    "astonish",
    "payback",
    "sucker-punch",
    "rage-powder",
    "clear-smog"
  ],
  "moves": [
    "solar-beam",
    "stun-spore",
    "synthesis",
    "night-slash",
    "phantom-force",
    "flatter",
    "power-whip",
    "aromatherapy",
    "grassy-terrain",
    "razor-leaf",
    "snatch",
    "night-daze",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 517,
    "item": null,
    "species": [
      {
        "name": "brute-bonnet",
        "order": 979,
        "types": [
          PokeType.GRASS,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 77,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
